import React from 'react';
import { CustomCellProps } from 'components/common/grid/';
import { Box } from '@mui/material';

export default function PreCell({ text, tooltip, subText, icon, rawHtml, align, rawTooltipHtml }: CustomCellProps) {
    return <Box sx={{ py: 1, whiteSpace: 'pre-wrap' }}>{text}</Box>;
}
